import React, { Component } from "react";
import ImageButtonList from "../common/imageButtonList";
import ImageBackground from "../common/imageBackground";
import ImageHeader from "../common/imageHeader";
import ImageText from "../common/imageText";
import PatientBanner from "../common/patientBanner";
import NavigationBar from "../common/navigationBar";
import "./styles.css";

export default class EducationLibraryOptions extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1255">
        <ImageBackground id="background" />
        <ImageHeader {...this.props.header} />
        <ImageText {...this.props.text} />
        <PatientBanner {...this.props.banner} />
        <ImageButtonList
          {...this.props.imageButtonsList}
          imageButtons={this.props.imageButtons}
        />
        <NavigationBar {...this.props.navigationBar} />
        <img className="btn-select" src={this.props.selectButton} alt="" />
      </div>
    );
  }
}
